import { ArrowsOutSimple, X } from "@phosphor-icons/react";
import { useRef, useState } from "react";
import { text } from "../i18n.js";
import { assetHref } from "../lib/routes.js";
import type { CommunityMediaView, Locale } from "../types.js";

export function Gallery({ locale, media, themeName }: {
  readonly locale: Locale;
  readonly media: readonly CommunityMediaView[];
  readonly themeName: string;
}) {
  const t = text(locale);
  const [selected, setSelected] = useState(0);
  const dialogRef = useRef<HTMLDialogElement>(null);
  const current = media[selected] ?? media[0];
  if (!current) return null;
  const alt = `${themeName} · ${t.media[current.kind]}`;
  return (
    <div className="gallery">
      <button className="gallery-main" type="button" onClick={() => dialogRef.current?.showModal()}>
        <img src={assetHref(current.url)} alt={alt} width={current.width} height={current.height} />
        <span><ArrowsOutSimple aria-hidden="true" />{locale === "zh-CN" ? "查看大图" : "View full size"}</span>
      </button>
      <div className="gallery-thumbs" role="group" aria-label={t.screenshots}>
        {media.map((item, index) => (
          <button
            key={`${item.kind}-${item.sha256}`}
            type="button"
            className={index === selected ? "selected" : ""}
            aria-pressed={index === selected}
            onClick={() => setSelected(index)}
          >
            <img src={assetHref(item.url)} alt="" width={item.width} height={item.height} loading="lazy" />
            <span>{t.media[item.kind]}</span>
          </button>
        ))}
      </div>
      <dialog className="image-dialog" ref={dialogRef} onClick={(event) => {
        if (event.currentTarget === event.target) event.currentTarget.close();
      }}>
        <button className="dialog-close" type="button" onClick={() => dialogRef.current?.close()}>
          <X aria-hidden="true" /><span>{locale === "zh-CN" ? "关闭" : "Close"}</span>
        </button>
        <img src={assetHref(current.url)} alt={alt} width={current.width} height={current.height} />
      </dialog>
    </div>
  );
}
